<div class="{{cid}}_feedback_blocks {{feedbackState}} {{class}}" 
     {{#unless prevent_focus}}tabindex="0"{{/unless}}>
</div>
